import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Body2, Caption1, SkeletonLoader } from "@activecollab/components";
import classNames from "classnames";
import PropTypes from "prop-types";
import { CopyButton } from "~/components/CopyToClipboard/CopyButton";

export const CopyField = ({ label, value, renderValue, onCopy, isLoading }) => {
  const { t } = useTranslation();

  const resolvedTooltipText = useMemo(() => {
    if (label.toLowerCase() === "token") {
      return t(`Copy token to clipboard`);
    }
    return t(`Copy {{label}} to clipboard`, { label: label });
  }, [label, t]);

  return (
    <div className="tw-flex tw-flex-col tw-gap-1">
      <Caption1 weight="bold">{label}</Caption1>

      <div className="tw-flex tw-gap-4 tw-items-center">
        {isLoading ? (
          <SkeletonLoader className="tw-w-[360px]" />
        ) : (
          <div className="tw-flex tw-w-full tw-max-w-[360px] tw-h-8 tw-items-center tw-border tw-rounded-md tw-border-solid tw-border-theme-500 tw-overflow-hidden">
            <Body2
              className={classNames("tw-items-center tw-min-w-0 tw-mx-2 tw-select-none", {
                "tw-flex": renderValue,
                "tw-flex-1": !renderValue,
              })}
              overflow="truncate"
              whitespace="no-wrap"
            >
              {renderValue ? renderValue(value) : value}
            </Body2>
          </div>
        )}

        <CopyButton
          label={label}
          value={value}
          onCopy={onCopy}
          isLoading={isLoading}
          tooltipText={resolvedTooltipText}
          size="medium"
        />
      </div>
    </div>
  );
};

CopyField.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  renderValue: PropTypes.func,
  onCopy: PropTypes.func,
  isLoading: PropTypes.bool,
};
